import { render, staticRenderFns } from "./events-list.vue?vue&type=template&id=00a3999a&scoped=true&"
import script from "./events-list.vue?vue&type=script&lang=js&"
export * from "./events-list.vue?vue&type=script&lang=js&"
import style0 from "./events-list.vue?vue&type=style&index=0&id=00a3999a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3999a",
  null
  
)

export default component.exports